exports = module.exports = require("../../../../node_modules/css-loader/lib/css-base.js")();
// imports


// module
exports.push([module.id, ".article-element {\n  height: 50vh;\n  width: 75vw;\n  position: relative;\n  border-left: 30px solid #fff;\n  border-right: 30px solid #fff;\n  border-top: 15px solid #fff;\n  border-bottom: 15px solid #fff; }\n\nh1.article-title {\n  color: white;\n  text-shadow: 0 0 5px black;\n  font-weight: 800;\n  text-align: center;\n  position: absolute;\n  top: 50%;\n  left: 50%;\n  -webkit-transform: translate(-50%, -50%);\n          transform: translate(-50%, -50%); }\n\n.bg-image {\n  width: 100%;\n  height: 100%;\n  overflow: hidden; }\n  .bg-image img {\n    min-width: 100%;\n    min-height: 100%; }\n\n.article-type {\n  position: absolute;\n  top: 15px;\n  right: 15px;\n  background-color: white;\n  padding: 1em;\n  text-transform: uppercase;\n  letter-spacing: .1em;\n  font-weight: 800; }\n", ""]);

// exports


/*** EXPORTS FROM exports-loader ***/
module.exports = module.exports.toString();


//////////////////
// WEBPACK FOOTER
// ./src/app/components/article-card/article-card.component.scss
// module id = 182
// module chunks = 1